import * as React from "react";

import { cn } from "@rivval/css";

const variants = {
  primary: "rgb(6 182 212)", // cyan-400
  secondary: "rgb(167 139 250)", // violet-400
  success: "rgb(163 230 53)", // lime-400
  warning: "rgb(250 204 21)", // yellow-400
  destructive: "rgb(239 68 68)", // red-800
  info: "rgb(96 165 250)", // blue-400
} as const;

interface DotPatternProps extends React.SVGProps<SVGSVGElement> {
  variant?: keyof typeof variants;
}

export function DotPattern({
  variant = "primary",
  className,
  ...props
}: DotPatternProps) {
  const color = variants[variant];

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 240 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      className={cn(className)}
      {...props}
    >
      <pattern
        id={`dot-pattern-${variant}`}
        x="0"
        y="0"
        width="6"
        height="6"
        patternUnits="userSpaceOnUse"
        patternContentUnits="userSpaceOnUse"
      >
        <circle cx="3" cy="3" r="0.1" fill={color} fillOpacity="0.6" />
      </pattern>
      <rect width="100%" height="100%" fill={`url(#dot-pattern-${variant})`} />
    </svg>
  );
}
